import Page from 'components/modules/public/pages/CategoryArticlesEmployee';
export default Page;